var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('span',{class:(_vm.color + "--text")},[_vm._v("●")]),_c('span',{staticClass:"status-label ml-2 text-uppercase"},[_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }